import { Loader } from "./Loader";

// El transform crea un contenedor para el #loader (position: fixed),
// así queda centrado en el área de contenido y no en toda la pantalla.
export default function ContentLoader() {
  return (
    <div className="relative w-full min-h-[calc(100vh-5rem)] md:min-h-[calc(100vh-3.5rem)]" style={{ transform: "translateZ(0)" }}>
      <Loader />
    </div>
  );
}
